<template lang="pug">
div
	v-e24-nav-bar
	SectionTitle(isAccordions='true' :srcImage='imgHeader', :tall="tall", h1="Checkout")
	section.maincolumn
		.checkout-main-wrapper
			.checkout-secondary-wrapper
				.wizard-steps
					span.step-number(:class="{ numberActiveColor: checkoutActiveTab === 'tab-report-options' }") 1
					span.step-txt(:class="{ textTxtActive: checkoutActiveTab === 'tab-report-options' }") Report Options&nbsp
					i(class="fa fa-angle-double-right step-txt" aria-hidden="true" :class="{ textTxtActive: checkoutActiveTab === 'tab-report-options'}" )
					span.step-number(:class="{ numberActiveColor: checkoutActiveTab === 'tab-delivery-options' }") 2
					span.step-txt(:class="{ textTxtActive: checkoutActiveTab === 'tab-delivery-options' }") Delivery&nbsp
					i(class="fa fa-angle-double-right step-txt" aria-hidden="true" :class="{ textTxtActive: checkoutActiveTab === 'tab-delivery-options' }")
					span.step-number(:class="{ numberActiveColor: checkoutActiveTab === 'tab-billing-data' }") 3
					span.step-txt(:class="{ textTxtActive: checkoutActiveTab === 'tab-billing-data' }") Billing&nbsp
					i(class="fa fa-angle-double-right step-txt" aria-hidden="true" :class="{ textTxtActive: checkoutActiveTab === 'tab-billing-data' }")
					span.step-number(:class="{ numberActiveColor: checkoutActiveTab === 'review-order' }") 4
					span.step-txt(:class="{ textTxtActive:  checkoutActiveTab === 'review-order'  }") Order

				.checkout-content(v-if="dataReady")
					#tab-report-options(v-if="checkoutActiveTab === 'tab-report-options' ")
						checkout-report-options(:products="products", :project="project", :sku="sku", :order="order")
					#tab-delivery-options(v-if="checkoutActiveTab === 'tab-delivery-options' ")
						checkout-delivery(:project="project", :products="products", :sku="sku", :chkOpt="chkOpt", :contacts="contacts")
					#tab-billing-data(v-if="checkoutActiveTab === 'tab-billing-data' ")
						checkout-billing(:products="products", :card="card", :contacts="contacts")
					#review-order(v-if="checkoutActiveTab === 'review-order' ")
						checkout-order(:card="card", :contacts="contacts", :project="project", :order="order")

		v-e24-footer(:build="build")
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import store from 'CommonApp/store'
import { mapState } from 'vuex'
import CheckoutReportOptions from './tabs-components/report-options.vue'
import CheckoutDelivery from './tabs-components/delivery.vue'
import CheckoutBilling from './tabs-components/billing.vue'
import CheckoutOrder from './tabs-components/order.vue'
import imageHeader from '@/common/img/list-project.jpg'
import SectionTitle from '@/common/components/sectionTitle.vue'
// import Person from 'Common/components/party/person.vue'
import readBuild from '../../util/readBuild'

export default {
	name: 'checkout',
	components: {
		CheckoutOrder,
		CheckoutBilling,
		CheckoutDelivery,
		CheckoutReportOptions,
		SectionTitle
	},
	params: ['projId', 'isNewHome', 'error'],
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data () {
		return {
			build: '',
			project: {},
			dataReady: false,
			products: false,
			contacts: [],
			order: null,
			config: null,
			card: {}, // card-form component will populate card object
			sku: {
				// Report options
				report: false,
				standardReport: 1001,
				plusAddtnReport: 1002,
				prelimRun: 2001,
				heatCoolLoad: 2002,
				rush: 3001,
				certify: 3002,
				// Delivery options
				email: 4001,
				email1r: 4002,
				hardCopy: 5001,
				hardCopyAddtnl: 5002,
				hardCopy1r: 5003
			},
			// Product options
			chkOpt: {
				delivery: {
					softCopyArrange: 0,
					softStandardFormat: '',
					hardCopyAddtnl: '',
					hardCopyShipto: '',
					hardCopySize: ''
				}
			},
			imgHeader: imageHeader,
			tall: 90
		}
	},
	created () {
	// this.onCheckoutTabChange('tab-billing-data')
	},
	methods: {
		onCheckoutTabChange (tabId) {
			console.debug('Checkout tab changed', tabId)
			store.dispatch({
				type: 'changeCheckoutActiveTab',
				value: tabId
			})
		}
	},
	beforeRouteEnter: (to, from, next) => {
		Vue.e24Common.productService.findAll().then(response => {
			next(vm => {
				vm.config = process.env.CHECKOUT

				Vue.e24.orderService.findOrderByProjId(to.params.projId).then(order => {
					if (!_.isNil(to.params.error)) {
					// Goto billing form tab
						store.dispatch({
							type: 'changeCheckoutActiveTab',
							value: 'tab-report-options'
						})

						vm.$notify({
							group: 'app',
							type: 'error',
							title: to.params.error.code + ' - ' + to.params.error.name,
							text: to.params.error.msg,
							duration: 5000
						})
					} else {
					// Default goto report options tab
						store.dispatch({
							type: 'changeCheckoutActiveTab',
							value: 'tab-report-options'
						})
					}

					console.debug('Order loaded', order)
					// Index by product sku
					// all available products
					let orderItems = null

					// Contemplate order products only if order is not yet set as paid
					if (!_.isNil(order) && (_.isNil(order.payment) || _.isNil(order.payment.approvalCode))) {
						if (order.orderStatus !== vm.config.orderStatus.cancelled.code) { // Not cancelled
							vm.order = order
							orderItems = order.items
						} else {
							console.log('The unpaid order found for this project is not going to be used because it was cancelled previously')
						}
					}

					vm.products = _.chain(response)
						.mapKeys(function (product) {
							return product.sku
						})
						.mapValues(function (product) {
							product.checked = !!(
								!_.isNil(orderItems) && _.find(orderItems, { sku: product.sku })
							)
							return product
						})
						.value()

					// if Addition
					if (!to.params.isNewHome) {
						vm.sku.report = vm.sku.plusAddtnReport
					} else {
						vm.sku.report = vm.sku.standardReport
					}

					console.log('loading products', vm.products)
					store.dispatch({
						type: 'loadProductList',
						value: response
					})

					vm.project = {
						projId: to.params.projId,
						isNewHome: to.params.isNewHome
					}

					vm.dataReady = true
				})
			})
		})
	},
	computed: mapState({
		checkoutActiveTab: state => state.checkoutActiveTab
	})
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/app/checkout/checkout.vue